export default __webpack_public_path__ + "static/etherscanquick-7f1b32d80b118ddb160e583668271d99.jpg";